import { copy } from "shared/assets";
import { IActionDropdownItem } from "shared/components";

const { actions: actionsCopy } = copy;

export const getUserCardActions = ({
  handleEdit,
  editDataTestId = "edit_user_card",
}: {
  handleEdit: () => void;
  editDataTestId?: string;
}): IActionDropdownItem[] => {
  const actions: IActionDropdownItem[] = [
    {
      label: actionsCopy.edit,
      handleClick: handleEdit,
      dataTestId: editDataTestId,
    },
  ];

  return actions;
};
